export const IMAGE_TOKEN = "{event_primary_image}";
export const TIME_UNTIL_EVENT_TOKEN = "{time_until_event}";
export const imageToken = { token: IMAGE_TOKEN };
export const imagePlaceholderRegex =
  /<(?:span|img)[^>]*data-image-token[^>]*>(?:.*?<\/span>)?/gi;

export const normalizeNewLines = (value?: string | null) =>
  (value ?? "").replace(/\\n/g, "\n");

export const htmlToPlainText = (value?: string | null) => {
  if (!value) return "";
  return value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/?div>/gi, "\n")
    .replace(/<\/?p>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

export const toStoredHtml = (value: string, placeholderRegex: RegExp) => {
  if (!value) return "";
  if (typeof DOMParser === "undefined") {
    return value
      .replace(placeholderRegex, IMAGE_TOKEN)
      .replace(
        /<[^>]*data-time-until-event[^>]*>.*?<\/[^>]+>/gi,
        TIME_UNTIL_EVENT_TOKEN,
      );
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, "text/html");
  const placeholders = doc.body.querySelectorAll("[data-image-token]");
  placeholders.forEach((node) => {
    const tokenText = doc.createTextNode(IMAGE_TOKEN);
    node.parentNode?.replaceChild(tokenText, node);
  });
  const timeUntilBadges = doc.body.querySelectorAll("[data-time-until-event]");
  timeUntilBadges.forEach((node) => {
    const tokenText = doc.createTextNode(TIME_UNTIL_EVENT_TOKEN);
    node.parentNode?.replaceChild(tokenText, node);
  });
  return doc.body.innerHTML || "";
};

export const hasImageToken = (value: string) => value.includes(IMAGE_TOKEN);

export const buildImagePlaceholderHtml = (
  primaryImageSrc: string | null,
  label: string,
): string => {
  if (primaryImageSrc) {
    return `<img data-image-token="true" src="${primaryImageSrc}" alt="${label}" style="max-width:100%;height:auto;border:1px dashed #cbd5e1;border-radius:8px;padding:4px;background:#f8fafc;" />`;
  }
  const fallbackLabel = label || "[Event image]";
  return `<span data-image-token="true" contenteditable="false" style="display:inline-flex;align-items:center;gap:6px;padding:6px 10px;border:1px dashed #cbd5e1;border-radius:6px;background:#f8fafc;color:#475569;font-size:12px;">${fallbackLabel}</span>`;
};

export const replaceImageTokensWithPlaceholder = (
  value: string,
  placeholderHtml: string,
) => (value ?? "").replaceAll(IMAGE_TOKEN, placeholderHtml);

export const buildTimeUntilEventBadgeHtml = (label: string) => {
  const text = label || TIME_UNTIL_EVENT_TOKEN;
  return `<span data-time-until-event="true" contenteditable="false" draggable="false" style="display:inline-flex;align-items:center;gap:6px;padding:6px 10px;border-radius:9999px;background:#e0f2fe;color:#0ea5e9;font-weight:600;font-size:12px;user-select:none;pointer-events:none;">${text}</span>`;
};

export const replaceTimeUntilEventToken = (value: string, badgeHtml: string) =>
  (value ?? "").replaceAll(TIME_UNTIL_EVENT_TOKEN, badgeHtml);

export const insertImageToken = (current: string) => {
  const isHtmlBody = current.includes("<");
  const needsSeparator =
    current.length > 0 &&
    !current.trim().endsWith("\n") &&
    !current.trim().endsWith("<br>") &&
    !current.trim().endsWith("<br />");
  const separator = needsSeparator ? (isHtmlBody ? "<br />" : "\n") : "";
  return `${current}${separator}${IMAGE_TOKEN}`;
};

export const insertTimeUntilEventToken = (current: string) => {
  const isHtmlBody = current.includes("<");
  const needsSeparator =
    current.length > 0 &&
    !current.trim().endsWith("\n") &&
    !current.trim().endsWith("<br>") &&
    !current.trim().endsWith("<br />");
  const separator = needsSeparator ? (isHtmlBody ? "<br />" : "\n") : "";
  return `${current}${separator}${TIME_UNTIL_EVENT_TOKEN}`;
};

export const toValidationPlainText = (value: string) =>
  normalizeNewLines(htmlToPlainText(value)).replaceAll(IMAGE_TOKEN, "").trim();
